import type {AxiosRequestConfig} from 'axios';

export class HttpError extends Error {
  readonly status: number;
  readonly body: unknown;

  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.body = body;
  }
}

export type HttpOptions = Omit<AxiosRequestConfig, 'url' | 'baseURL' | 'data'> & {
  body?: unknown;
  /** Query-параметры. Конвертируются в snake_case автоматически. */
  params?: Record<string, string | number | boolean | undefined | null>;
  /** Если true — не префиксуем `/v1`. */
  withoutVersion?: boolean;
  /** Если true — не префиксуем `/office`. */
  withoutOffice?: boolean;
  /** Если true — не конвертируем case в теле/ответе. */
  skipCaseConversion?: boolean;
  /** Если true — ответ не распаковывается из {payload} обёртки. */
  rawResponse?: boolean;
};
